import { all, call, put, takeLatest, select } from 'redux-saga/effects'
import EmailSettingsAction, {
  EmailSettingsTypes,
} from '../Redux/EmailSettingsRedux'

export function* onUpdate(api, action) {
  const resp = yield call(api.updateEmailSettings, action.params)
  if (resp.ok) {
    yield put(EmailSettingsAction.emailSettingsUpdateSuccess(resp.data))
    action.callback(resp.data)
  } else {
    yield put(
      EmailSettingsAction.emailSettingsUpdateFailure('something went wrong')
    )
    action.callback(resp.data)
  }
}

export function* onUpsert(api, action) {
  const resp = yield call(api.upsertTextEmailSettings, action.params)
  if (resp.ok) {
    yield put(EmailSettingsAction.emailSettingsUpsertSuccess(resp.data))
    action.callback(resp.data)
  } else {
    yield put(
      EmailSettingsAction.emailSettingsUpsertFailure('something went wrong')
    )
    action.callback(resp.data)
  }
}

export function* detailsRequest(api, action) {
  const resp = yield call(api.getEmailSettings)
  if (resp.ok) {
    yield put(EmailSettingsAction.emailSettingsDetailSuccess(resp.data))
  } else {
    yield put(
      EmailSettingsAction.emailSettingsDetailFailure('something went wrong')
    )
  }
}

export function* textDetailsRequest(api, action) {
  const resp = yield call(api.getTextEmailSettings)
  if (resp.ok) {
    yield put(EmailSettingsAction.emailSettingsTextDetailSuccess(resp.data))
  } else {
    yield put(
      EmailSettingsAction.emailSettingsTextDetailFailure('something went wrong')
    )
  }
}

export function* sendVerificationEmail(api, action) {
  const resp = yield call(api.sendVerificationEmail)
}

export default function* authSagas(api) {
  yield all([
    takeLatest(EmailSettingsTypes.EMAIL_SETTINGS_UPDATE_REQUEST, onUpdate, api),
    takeLatest(EmailSettingsTypes.EMAIL_SETTINGS_UPSERT_REQUEST, onUpsert, api),
    takeLatest(
      EmailSettingsTypes.EMAIL_SETTINGS_DETAIL_REQUEST,
      detailsRequest,
      api
    ),
    takeLatest(
      EmailSettingsTypes.EMAIL_SETTINGS_TEXT_DETAIL_REQUEST,
      textDetailsRequest,
      api
    ),
    takeLatest(
      EmailSettingsTypes.RESEND_VERIFICATION_EMAIL,
      sendVerificationEmail,
      api
    ),
  ])
}
